import React, { useEffect } from 'react';
import { useGame } from '../../contexts/GameContext';
import './BattleRequestWindow.css';

interface BattleRequestWindowProps {
  characterId: string;
  characterNickname: string;
}

const BattleRequestWindow: React.FC<BattleRequestWindowProps> = () => {
  const { 
    state, 
    createBattleRequest, 
    cancelBattleRequest, 
    acceptBattleRequest,
    loadBattleRequests,
    loadMyActiveRequest 
  } = useGame();
  const { battleRequests, myActiveRequest } = state;
  const [isCreating, setIsCreating] = React.useState(false);

  useEffect(() => {
    // Загружаем данные только при монтировании
    // Все обновления будут приходить через события
    loadBattleRequests();
    loadMyActiveRequest();
  }, [loadBattleRequests, loadMyActiveRequest]);

  const handleCreateRequest = () => {
    setIsCreating(true);
    createBattleRequest();
    // Сброс состояния происходит через события
    setTimeout(() => setIsCreating(false), 1000);
  };

  const handleCancelRequest = () => {
    if (myActiveRequest) {
      cancelBattleRequest(myActiveRequest.id);
    }
  };

  const handleAcceptRequest = (requestId: string) => {
    acceptBattleRequest(requestId);
  };

  const formatTimeRemaining = (expiresAt: string) => {
    const now = new Date().getTime();
    const expires = new Date(expiresAt).getTime();
    const diff = expires - now;
    
    if (diff <= 0) return 'Истекла';
    
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="battle-request-content">
      <div className="battle-request-header">
        {myActiveRequest ? (
          <div className="my-active-request">
            <span>Ваша заявка активна (осталось {formatTimeRemaining(myActiveRequest.expires_at)})</span>
            <button 
              className="btn-cancel"
              onClick={handleCancelRequest}
            >
              Отменить
            </button>
          </div>
        ) : (
          <button 
            className="btn-create"
            onClick={handleCreateRequest}
            disabled={isCreating}
          >
            {isCreating ? 'Создание...' : 'Создать заявку'}
          </button>
        )}
      </div>

      <div className="battle-request-list-container">
        {battleRequests.length === 0 ? (
          <div className="no-requests">Нет активных заявок</div>
        ) : (
          <div className="requests-list">
            {battleRequests.map(request => (
              <div key={request.id} className="request-item">
                <span className="request-icon">⚔️</span>
                <div className="request-details">
                  <span className="request-player">{request.challenger_nickname}</span>
                  <span className="request-info">Ур: {request.challenger_level}, {request.challenger_class_name}</span>
                </div>
                <span className="request-time">{formatTimeRemaining(request.expires_at)}</span>
                <button 
                  className="btn-accept"
                  onClick={() => handleAcceptRequest(request.id)}
                  disabled={!!myActiveRequest}
                >
                  Принять
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BattleRequestWindow;
